import { Button } from "react-bootstrap";
import { BinIcon } from "../../../../components/icon/Icon";
import React, { useCallback } from "react";
import {
    MobilePositionCreateTopUpIconStyled,
    MobilePositionCreateTopUpStyled
} from "./styled/MobilePositionCreateTopUpStyled";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { openMobileSliderPageAction } from "../../../mobileAppActions";
import { MOBILE_SLIDER_PAGES_IDS } from "../../MobileSliderPages/mobileSliderPagesConstants";
import { useDispatch } from "react-redux";

function MobilePositionCreateTopUpBanner() {
    const {getLangPath} = useLangContext();
    const dispatch = useDispatch();

    const handleBannerClick = useCallback(() => {
        dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.DEPOSIT));
    }, [dispatch]);

    return <MobilePositionCreateTopUpStyled>
        <MobilePositionCreateTopUpIconStyled>
            <img src={`${process.env.PUBLIC_URL}/assets/deposit/coin-grey.png`} alt={'deposit-coin-grey'}/>
        </MobilePositionCreateTopUpIconStyled>
        <p>{getLangPath('deposit.you_havent_funded_top_up')}</p>
        <Button variant={'primary'} size={'lg'} onClick={handleBannerClick}>
            <BinIcon name={'IcPlus'}/>
            <span className={'ms-2'}>{getLangPath('lite_version.home.top_up')}</span>
        </Button>
    </MobilePositionCreateTopUpStyled>
}

export default MobilePositionCreateTopUpBanner;
